import Skeleton from "react-loading-skeleton";

export const MailShipping = ({ shipCost }) => {
  return (
    <div className="shipping-method mail-shipping">
      <div className="shipping-method-info">
        <div>
          <input className="form-check-input" type="radio" name="shippingMethod" id="shippingMethod3" disabled={true} />
        </div>
        <label className="form-check-label" htmlFor="shippingMethod3">
          <div className={"d-flex justify-content-between align-items-center"}>
            <div>Mail</div>
            <div>
              <Skeleton width={50} />
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};
